import { useMemo } from 'react';

import { useLoggedInEmployeeId, useLoggedInUserRoles } from '~/components/Auth';
import { useLegacyAllowanceHistoricalProposal } from '~/data/proposals/useGetLegacyHistoricalProposals';
import { useSelectedEmployeeId } from '~/hooks/employee/useSelectedEmployeeId';
import { isRoleHRAdmin } from '~/services/Permissions';

import { useAllowanceProposalColumns } from '../../common';
import {
  AllowanceProposalWorkflowTable,
  ProposalsHistoryTableLayout,
} from '../components';

export const AllowanceProposalHistoryTable = () => {
  const columns = useAllowanceProposalColumns();
  const roles = useLoggedInUserRoles();
  const isHRAdmin = isRoleHRAdmin(roles);
  const loggedInId = useLoggedInEmployeeId();
  const { selectedEmployeeId: employeeId } = useSelectedEmployeeId();
  const { data } = useLegacyAllowanceHistoricalProposal({
    employeeId,
  });

  const rows = useMemo(() => {
    if (loggedInId === employeeId && !isHRAdmin) {
      return data.filter((item) => item.fAllowanceProposalStatus !== 'FAILED');
    }

    return data;
  }, [data, loggedInId, employeeId, isHRAdmin]);

  return (
    <ProposalsHistoryTableLayout
      rows={rows}
      columns={columns}
      employeeId={employeeId}
      proposalWorkflowTable={AllowanceProposalWorkflowTable}
    />
  );
};
